<template>
  <div>
    <div class="my-back">
      <img src="../assets/logo.png" class="my-logo" />
      <icon
        :name="iconName"
        color="#ffffff"
        style="margin-right: 1.5rem"
        size="25"
        v-if="showMenu"
        @click="showPopup"
      />
    </div>
    <div class="my-back-placeholder"></div>
    <van-search
      class="search_block"
      v-model="searchValue"
      show-action
      placeholder="站内搜索"
      maxlength="32"
      @search="onSearch"
      @cancel="onCancel"
    >
      <template #action>
        <div v-if="!searchState" @click="onSearch">搜索</div>
        <div v-else @click="onCancel">清空</div>
      </template>
    </van-search>

    <popup v-model="show" round position="top" style="height: 100%">
      <div class="my-body">
        <cell is-link v-for="(v, i) in list" @click="to(v)" :icon="v.icon">{{
          v.xwName
        }}</cell>
      </div>
    </popup>
  </div>
</template>

<script>
import { Popup, Cell, Icon} from "vant";
import service from "../api/service";

export default {
  name: "homeHead",
  components: { Icon, Popup, Cell },
  props: {
    showMenu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      iconName: "apps-o",
      show: false,
      list: [],
      searchValue: "",
    };
  },
  computed: {
    searchState() {
      console.warn("route", this.$route.path);
      return this.$route.path == "/search";
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    onSearch() {
      console.info("search");
      if (!this.searchValue) {
        this.$toast("搜索内容不能为空");
        return;
      }

      this.$router.push({ path: "/search" ,query:{value:this.searchValue}});
    },
    onCancel() {
      console.info("cancel");
      this.searchValue = "";
      this.$router.push({ path: "/home" });
    },
    init() {
      service
        .get("/api/xw/topTitleBar", { position: "菜单栏目" })
        .then((res) => {
          if (res.status === 200) {
            this.list = res.data;
          }
        });
    },
    //菜单显示
    showPopup() {
      this.show = !this.show;
      this.iconName = this.iconName === "apps-o" ? "cross" : "apps-o";
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      let t = document.querySelector(".my-back");
      debugger;
      return t;
    },
    to(v) {
      this.$store.state.detailList = {
        label: v.xwName,
        id: v.id,
        icon: v.icon,
        bacImg: v.bacImg,
      };
      this.$router.push({ path: "/detailList" });
    },
  },
};
</script>

<style scoped>
.search_block {
  /* position: absolute;
  top:56rpx; */
  width: 100%;
  z-index: 2;
}

.my-back {
  height: 56px;
  position: fixed;
  top: 0;
  background-image: url("../assets/header_bg.png");
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 99999999;
}

.my-back-placeholder {
  height: 56px;
}

.my-logo {
  height: 1.5rem;
  margin-left: 1.5rem;
}

.my-body {
  margin-top: 56px;
}
</style>